module.exports = __webpack_public_path__ + "img/Group 14.fb391c08.svg";